/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type ReportFilters_report = {|
  +widgets: ?$ReadOnlyArray<?{|
    +mongoId: ?string;
    +config: ?{|
      +question: ?{|
        +firstAnswerTime: ?string;
        +firstAnswerTimeByDevice: ?$ReadOnlyArray<?{|
          +globalId: string;
          +deviceId: ?string;
          +localTime: ?string;
          +id: string;
        |}>;
        +type: ?string;
      |};
      +useNumbers: ?boolean;
    |};
  |}>;
  +filters: ?$ReadOnlyArray<?{|
    +type: ?string;
    +locked: ?$ReadOnlyArray<?number>;
  |}>;
  +devices: ?$ReadOnlyArray<?{|
    +id: string;
    +tags: ?$ReadOnlyArray<?string>;
  |}>;
  +showTagsFilter: ?boolean;
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ReportFilters_report",
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "Widget",
      "name": "widgets",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "mongoId",
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "WidgetConfig",
          "name": "config",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "args": null,
              "concreteType": "Question",
              "name": "question",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "args": null,
                  "name": "firstAnswerTime",
                  "storageKey": null
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "args": null,
                  "concreteType": "FirstAnswerTimeByDevice",
                  "name": "firstAnswerTimeByDevice",
                  "plural": true,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "args": null,
                      "name": "globalId",
                      "storageKey": null
                    },
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "args": null,
                      "name": "deviceId",
                      "storageKey": null
                    },
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "args": null,
                      "name": "localTime",
                      "storageKey": null
                    },
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "args": null,
                      "name": "id",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "args": null,
                  "name": "type",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "useNumbers",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "ReportFilter",
      "name": "filters",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "type",
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "locked",
          "storageKey": null
        },
        {
          "kind": "FragmentSpread",
          "name": "OptionPicker_filter",
          "args": null
        }
      ],
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "DevicePicker_report",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "DateRangePicker_report",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "OptionPicker_report",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "TagPicker_report",
      "args": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "Device",
      "name": "devices",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "id",
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "tags",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "showTagsFilter",
      "storageKey": null
    }
  ],
  "type": "Report"
};

module.exports = fragment;



// WEBPACK FOOTER //
// ./src/scenes/Report/components/ReportWrapper/components/ReportHeader/components/ReportFilters/__generated__/ReportFilters_report.graphql.js